/** Строки актуализации KMP: русский, английский, азербайджанский. */
export const refreshMessages = {
  plannerDate: ['Дата', 'Date', 'Tarix'],
  plannerLocations: ['Места оказания услуг', 'Service locations', 'Xidmət məkanları'],
  localPlanner: ['Локальный план', 'Local planner', 'Lokal plan'],
  localPlannerHint: [
    'Циклы, исключения и отпуска сохраняются для вашего аккаунта только в этом браузере. Они не изменяют доступные клиентам слоты онлайн-записи.',
    'Cycles, day exceptions and vacations are saved for your account in this browser only. They do not change the online booking slots available to clients.',
    'Dövrlər, gün istisnaları və məzuniyyətlər hesabınız üçün yalnız bu brauzerdə saxlanılır. Müştərilər üçün onlayn rezervasiya vaxtlarını dəyişmir.',
  ],
  newLocalSchedule: [
    'Создать локальное расписание',
    'Create local schedule',
    'Lokal cədvəl yarat',
  ],
  plannerStorageError: [
    'Не удалось сохранить план в браузере. Проверьте доступ к хранилищу.',
    'Could not save the plan in this browser. Check storage access.',
    'Plan brauzerdə saxlanılmadı. Yaddaşa girişi yoxlayın.',
  ],
  plannerWeekdays: ['По дням недели', 'By weekday', 'Həftənin günləri üzrə'],
  plannerEvenWeeks: ['По чётным числам', 'Even calendar dates', 'Cüt tarixlərdə'],
  plannerOddWeeks: ['По нечётным числам', 'Odd calendar dates', 'Tək tarixlərdə'],
  plannerTwoOnTwoOff: [
    'Два через два',
    'Two days on, two days off',
    'İki iş günü, iki istirahət günü',
  ],
  plannerCustom: ['Свой цикл', 'Custom cycle', 'Fərdi dövr'],
  plannerDay: ['Предпросмотр недели', 'Week preview', 'Həftəyə ön baxış'],
  plannerEditDay: ['Изменить день', 'Edit day', 'Günü dəyiş'],
  plannerResetDay: [
    'Вернуть правила расписания',
    'Restore schedule rules',
    'Cədvəl qaydalarını bərpa et',
  ],
  plannerWorking: ['Рабочий день', 'Working day', 'İş günü'],
  plannerDayOff: ['Выходной', 'Day off', 'İstirahət günü'],
  plannerVacation: ['Отпуск', 'Vacation', 'Məzuniyyət'],
  plannerAddVacation: ['Добавить отпуск', 'Add vacation', 'Məzuniyyət əlavə et'],
  plannerListing: ['Объявление', 'Listing', 'Elan'],
  plannerAllListings: ['Все объявления', 'All listings', 'Bütün elanlar'],
  plannerEmptySelection: [
    'Ничего не выбрано — применяем ко всем.',
    'No selection means all items.',
    'Seçim yoxdursa, hamısına tətbiq olunur.',
  ],
  plannerPattern: ['Повторение', 'Recurrence', 'Təkrarlanma'],
  plannerWorkDays: [
    'Рабочих дней в цикле',
    'Working days per cycle',
    'Dövrdə iş günləri',
  ],
  plannerRestDays: [
    'Выходных дней в цикле',
    'Days off per cycle',
    'Dövrdə istirahət günləri',
  ],
  plannerDayType: ['Тип дня', 'Day type', 'Günün növü'],
  plannerOverlap: [
    'Расписание пересекается с другим планом для этих услуг и мест. Измените дни или время.',
    'This schedule overlaps another plan for these services and locations. Change the days or times.',
    'Cədvəl bu xidmətlər və məkanlar üçün başqa planla üst-üstə düşür. Günləri və ya vaxtı dəyişin.',
  ],
  plannerDeleteConfirm: [
    'Удалить локальное расписание? Серверные записи клиентов сохранятся.',
    'Delete this local schedule? Existing server bookings will remain.',
    'Lokal cədvəl silinsin? Serverdəki rezervasiyalar saxlanılacaq.',
  ],
  scheduleSend: ['Запланировать отправку', 'Schedule message', 'Mesajı planlaşdır'],
  listingIntegerPrice: [
    'Цена — целое неотрицательное число',
    'Price must be a non-negative integer',
    'Qiymət mənfi olmayan tam ədəd olmalıdır',
  ],
  listingInvalidPriceRange: [
    'Верхняя граница должна быть не меньше цены',
    'Maximum price must not be lower than the price',
    'Maksimum qiymət qiymətdən az olmamalıdır',
  ],
  listingRentalPeriod: [
    'Выберите период аренды',
    'Select a rental period',
    'İcarə müddətini seçin',
  ],
  listingLocationInvalid: [
    'Укажите точку на карте',
    'Choose a location on the map',
    'Xəritədə məkan seçin',
  ],
  actionFailed: [
    'Действие не выполнено. Повторите попытку.',
    'The action failed. Please try again.',
    'Əməliyyat alınmadı. Yenidən cəhd edin.',
  ],
  ageFrom: ['Возраст от', 'Minimum age', 'Minimum yaş'],
  ageTo: ['Возраст до', 'Maximum age', 'Maksimum yaş'],
  addPhoto: ['Добавить фото', 'Add photo', 'Şəkil əlavə et'],
  distance: ['Расстояние', 'Distance', 'Məsafə'],
  foundCount: ['Найдено: {{count}}', 'Found: {{count}}', 'Tapıldı: {{count}}'],
  moveLeft: ['Переместить влево', 'Move left', 'Sola keçir'],
  moveFirst: ['Переместить в начало', 'Move to beginning', 'Əvvələ keçir'],
  deleteGiftConfirm: [
    'Удалить подарок с полки? Вернуть его будет нельзя.',
    'Remove this gift from your shelf? This cannot be undone.',
    'Hədiyyə rəfdən silinsin? Bunu geri qaytarmaq olmaz.',
  ],
  markRead: ['Отметить прочитанным', 'Mark as read', 'Oxunmuş kimi işarələ'],
  verify: ['Пройти проверку', 'Verify identity', 'Kimliyi təsdiqlə'],
  view: ['Посмотреть', 'View', 'Bax'],
  report: ['Пожаловаться', 'Report', 'Şikayət et'],
  block: ['Заблокировать', 'Block', 'Blokla'],
  editProfile: ['Редактировать профиль', 'Edit profile', 'Profili redaktə et'],
  sessions: ['Устройства и сеансы', 'Devices and sessions', 'Cihazlar və sessiyalar'],
  currentSession: ['Это устройство', 'This device', 'Bu cihaz'],
  revokeSession: ['Завершить сеанс', 'End session', 'Sessiyanı bitir'],
  revokeOtherSessions: [
    'Завершить остальные сеансы',
    'End other sessions',
    'Digər sessiyaları bitir',
  ],
  BALANCE_POSITIVE: ['Остаток Kelvin', 'Remaining Kelvin', 'Qalan Kelvin'],
  ESCROW_HOLD: [
    'Средства в защищённых сделках',
    'Funds held in protected deals',
    'Qorunan əməliyyatlardakı vəsait',
  ],
  WITHDRAWAL_PENDING: ['Незавершённый вывод', 'Pending withdrawal', 'Gözləyən çıxarış'],
  restoreChat: ['Вернуть из архива', 'Restore from archive', 'Arxivdən qaytar'],
  leaveDatingMatch: ['Завершить знакомство', 'End match', 'Tanışlığı bitir'],
  schedule: ['Запланировать', 'Schedule', 'Planlaşdır'],
  removeAttachment: ['Убрать вложение', 'Remove attachment', 'Əlavəni sil'],
  PENDING: ['Ожидает отправки', 'Pending', 'Göndərilmə gözlənilir'],
  SENT: ['Отправлено', 'Sent', 'Göndərildi'],
  CANCELED: ['Отменено', 'Canceled', 'Ləğv edildi'],
  FAILED: ['Не отправлено', 'Failed', 'Göndərilmədi'],
  freeRemaining: [
    'Бесплатных публикаций осталось: {{count}} из {{total}}',
    'Free publications remaining: {{count}} of {{total}}',
    'Qalan pulsuz dərclər: {{total}} saydan {{count}}',
  ],
  reserveSlot: [
    'Проверить цену и зарезервировать время',
    'Review price and reserve time',
    'Qiyməti yoxla və vaxtı rezerv et',
  ],
  remainingAtMeeting: [
    'Остаток при встрече',
    'Remainder at the appointment',
    'Görüş zamanı qalan məbləğ',
  ],
  reservationUntil: ['Резерв до', 'Reserved until', 'Rezerv müddəti'],
  reservationSelectionChanged: [
    'Предыдущий резерв ещё действует. Вернитесь к прежнему выбору или дождитесь его окончания.',
    'Your previous reservation is still active. Restore the previous selection or wait for it to expire.',
    'Əvvəlki rezerv aktivdir. Əvvəlki seçimi bərpa edin və ya müddətinin bitməsini gözləyin.',
  ],
  reserveAgain: [
    'Создать новый резерв',
    'Create a new reservation',
    'Yeni rezerv yarat',
  ],
  alreadyReported: [
    'Жалоба уже отправлена',
    'Already reported',
    'Şikayət artıq göndərilib',
  ],
  reportUnavailable: [
    'Жалоба для этого объекта недоступна',
    'Reporting is unavailable for this item',
    'Bu obyektə şikayət etmək mümkün deyil',
  ],
  moderationDecision: ['Решение модерации', 'Moderation decision', 'Moderasiya qərarı'],
  appealText: [
    'Почему решение стоит пересмотреть',
    'Why the decision should be reviewed',
    'Qərar niyə yenidən nəzərdən keçirilməlidir',
  ],
  nicknameTaken: [
    'Этот никнейм уже занят',
    'This username is taken',
    'Bu istifadəçi adı tutulub',
  ],
  datingStart: ['Создать анкету', 'Create dating profile', 'Tanışlıq profili yarat'],
  datingIntro: [
    'Знакомьтесь с людьми, которым близки ваши цели и интересы.',
    'Meet people who share your goals and interests.',
    'Məqsəd və maraqlarınızı bölüşən insanlarla tanış olun.',
  ],
  datingOwn: ['Моя анкета', 'My dating profile', 'Mənim tanışlıq profilim'],
  datingIncoming: ['Входящие симпатии', 'Incoming likes', 'Gələn bəyənmələr'],
  datingOutgoing: ['Мои симпатии', 'My likes', 'Mənim bəyənmələrim'],
  datingMatches: ['Совпадения', 'Matches', 'Qarşılıqlı bəyənmələr'],
  datingNotifications: [
    'Уведомления знакомств',
    'Dating notifications',
    'Tanışlıq bildirişləri',
  ],
  datingHidden: ['Ваша анкета скрыта', 'Your profile is hidden', 'Profiliniz gizlidir'],
  datingBlocked: [
    'Анкета ограничена модерацией',
    'Profile restricted by moderation',
    'Profil moderasiya tərəfindən məhdudlaşdırılıb',
  ],
  datingInactive: [
    'Анкета больше не активна',
    'Profile is no longer active',
    'Profil artıq aktiv deyil',
  ],
  datingAge: [
    'Знакомства доступны с 18 лет',
    'Dating is available from age 18',
    'Tanışlıq 18 yaşdan etibarən mümkündür',
  ],
  datingAccount: [
    'Заполните имя, дату рождения и пол в основном профиле.',
    'Complete your first name, birthday and gender in your account.',
    'Hesabınızda adınızı, doğum tarixinizi və cinsinizi doldurun.',
  ],
  datingVerify: [
    'Подтвердите уникальность, чтобы опубликовать анкету.',
    'Verify your identity to publish your profile.',
    'Profilinizi dərc etmək üçün kimliyinizi təsdiqləyin.',
  ],
  goals: ['Цели знакомства', 'Dating goals', 'Tanışlıq məqsədləri'],
  RELATIONSHIP: ['Отношения', 'Relationship', 'Münasibət'],
  DATES: ['Свидания', 'Dates', 'Görüşlər'],
  COMMUNICATION: ['Общение', 'Conversation', 'Ünsiyyət'],
  UNSURE: ['Пока не определился', 'Still figuring it out', 'Hələ qərar verməmişəm'],
  audience: ['С кем знакомиться', 'Who to meet', 'Kiminlə tanış olmaq'],
  MALE: ['Мужчины', 'Men', 'Kişilər'],
  FEMALE: ['Женщины', 'Women', 'Qadınlar'],
  datingPhotos: ['Фотографии анкеты', 'Profile photos', 'Profil şəkilləri'],
  datingTags: ['Интересы и ценности', 'Interests and values', 'Maraqlar və dəyərlər'],
  IN_PEOPLE: ['В людях', 'In people', 'İnsanlarda'],
  IN_LIFE: ['В жизни', 'In life', 'Həyatda'],
  TOGETHER: ['Вместе', 'Together', 'Birlikdə'],
  customTag: ['Свой интерес', 'Custom interest', 'Şəxsi maraq'],
  bio: ['О себе', 'About me', 'Haqqımda'],
  publish: ['Опубликовать', 'Publish', 'Dərc et'],
  hide: ['Скрыть', 'Hide', 'Gizlət'],
  show: ['Показать', 'Show', 'Göstər'],
  pendingModeration: ['На проверке', 'Under review', 'Yoxlanılır'],
  rejected: ['Отклонено', 'Rejected', 'Rədd edilib'],
  skip: ['Пропустить', 'Skip', 'Keç'],
  like: ['Нравится', 'Like', 'Bəyən'],
  superlike: ['Суперлайк', 'Superlike', 'Super bəyənmə'],
  matchCreated: ['Взаимная симпатия!', 'It is a match!', 'Qarşılıqlı bəyənmə!'],
  chatPreparing: [
    'Чат создаётся. Он появится в списке чатов.',
    'Your chat is being created. It will appear in Chats.',
    'Çat yaradılır. Çatlar siyahısında görünəcək.',
  ],
  doNotShow: ['Больше не показывать', 'Do not show again', 'Bir daha göstərmə'],
  revokeLike: ['Отозвать симпатию', 'Revoke like', 'Bəyənməni geri götür'],
  buySuperlikes: ['Купить суперлайки', 'Buy superlikes', 'Super bəyənmələr al'],
  noDistanceLimit: [
    'Без ограничения расстояния',
    'No distance limit',
    'Məsafə məhdudiyyəti yoxdur',
  ],
  confirmDeleteProfile: [
    'Удалить анкету знакомств? Совпадения и чаты будут закрыты.',
    'Delete your dating profile? Matches and dating chats will close.',
    'Tanışlıq profili silinsin? Uyğunluqlar və tanışlıq çatları bağlanacaq.',
  ],
  giftShelf: ['Полка подарков', 'Gift shelf', 'Hədiyyə rəfi'],
  hiddenGifts: ['Скрытые подарки', 'Hidden gifts', 'Gizli hədiyyələr'],
  giftMessage: ['Сообщение к подарку', 'Gift message', 'Hədiyyə mesajı'],
  sendGift: ['Подарить', 'Send gift', 'Hədiyyə et'],
  giftSent: ['Подарок отправлен', 'Gift sent', 'Hədiyyə göndərildi'],
  giftUnknown: [
    'Отправка уточняется. Повторная покупка заблокирована.',
    'Delivery is being checked. Another purchase is blocked.',
    'Göndərilmə yoxlanılır. Təkrar alış bloklanıb.',
  ],
  archiveList: ['Архив', 'Archive', 'Arxiv'],
  savedChat: ['Избранное', 'Saved messages', 'Yadda saxlanmış mesajlar'],
  scheduledMessages: [
    'Отложенные сообщения',
    'Scheduled messages',
    'Planlaşdırılmış mesajlar',
  ],
  sendAt: [
    'Отправить в указанное время',
    'Send at selected time',
    'Seçilmiş vaxtda göndər',
  ],
  sendWhenOnline: ['Когда появится в сети', 'When online', 'Onlayn olduqda'],
  sendNow: ['Отправить сейчас', 'Send now', 'İndi göndər'],
  closedDatingChat: [
    'Знакомство завершено. Отправка сообщений недоступна.',
    'This match has ended. Messaging is unavailable.',
    'Tanışlıq bitib. Mesaj göndərmək mümkün deyil.',
  ],
  clearForEveryone: [
    'Очистить для обоих',
    'Clear for both',
    'Hər iki tərəf üçün təmizlə',
  ],
  publicationPrice: ['Стоимость публикации', 'Publication price', 'Dərc qiyməti'],
  freePublication: ['Бесплатная публикация', 'Free publication', 'Pulsuz dərc'],
  renewPublication: ['Продлить публикацию', 'Renew publication', 'Dərci uzat'],
  publicationDays: [
    'Срок: {{count}} дней',
    'Duration: {{count}} days',
    'Müddət: {{count}} gün',
  ],
  priceChanged: [
    'Цена изменилась. Проверьте новую сумму перед подтверждением.',
    'The price changed. Review the new amount before confirming.',
    'Qiymət dəyişib. Təsdiqdən əvvəl yeni məbləği yoxlayın.',
  ],
  serviceCatalog: ['Каталог услуг', 'Service catalog', 'Xidmət kataloqu'],
  proposeService: ['Предложить услугу', 'Suggest a service', 'Xidmət təklif et'],
  reservationExpired: [
    'Время резерва истекло. Выберите время заново.',
    'The reservation expired. Select a time again.',
    'Rezervin vaxtı bitib. Vaxtı yenidən seçin.',
  ],
  protectedAmount: ['Защищённая сумма', 'Protected amount', 'Qorunan məbləğ'],
  commission: ['Комиссия', 'Fee', 'Komissiya'],
  furtSoon: ['Фурт скоро откроется', 'Furt is coming soon', 'Furt tezliklə açılacaq'],
  remindLaunch: ['Сообщить об открытии', 'Notify me at launch', 'Açılışda xəbər ver'],
  reminderSaved: [
    'Напомним об открытии',
    'We will notify you at launch',
    'Açılışda xəbər verəcəyik',
  ],
  reportReason: ['Причина жалобы', 'Report reason', 'Şikayət səbəbi'],
  appeal: ['Обжаловать решение', 'Appeal decision', 'Qərardan şikayət et'],
  appealSent: ['Обращение отправлено', 'Appeal submitted', 'Müraciət göndərildi'],
  profileUnavailable: [
    'Профиль недоступен',
    'Profile unavailable',
    'Profil əlçatmazdır',
  ],
  deletionBlocked: [
    'Перед удалением завершите обязательства',
    'Complete outstanding obligations before deleting',
    'Silmədən əvvəl öhdəlikləri tamamlayın',
  ],
  workExperience: ['Опыт работы', 'Work experience', 'İş təcrübəsi'],
  LessThanOneYear: ['Меньше года', 'Less than a year', 'Bir ildən az'],
  OneToThreeYears: ['1–3 года', '1–3 years', '1–3 il'],
  ThreeToFiveYears: ['3–5 лет', '3–5 years', '3–5 il'],
  FiveToTenYears: ['5–10 лет', '5–10 years', '5–10 il'],
  MoreThanTenYears: ['Больше 10 лет', 'Over 10 years', '10 ildən çox'],
  acceptsCalls: ['Принимаю звонки', 'Accept calls', 'Zəngləri qəbul et'],
  education: ['Образование', 'Education', 'Təhsil'],
  institution: ['Учебное заведение', 'Institution', 'Təhsil müəssisəsi'],
  specialty: ['Специальность', 'Specialty', 'İxtisas'],
  startYear: ['Год начала', 'Start year', 'Başlanğıc ili'],
  endYear: ['Год окончания', 'End year', 'Bitmə ili'],
  studyingNow: ['Учусь сейчас', 'Currently studying', 'Hazırda təhsil alıram'],
  addEducation: ['Добавить образование', 'Add education', 'Təhsil əlavə et'],
  addDiploma: ['Добавить диплом', 'Add qualification', 'Diplom əlavə et'],
  portfolio: ['Портфолио', 'Portfolio', 'Portfolio'],
  serviceLocations: ['Места оказания услуг', 'Service locations', 'Xidmət yerləri'],
  locationDetails: [
    'Как добраться и другие детали',
    'Directions and details',
    'Ünvan və əlavə məlumat',
  ],
  AtWorkplace: ['В рабочем помещении', 'At a workplace', 'İş yerində'],
  AtSpecialistHome: [
    'На дому у специалиста',
    'At the specialist’s home',
    'Mütəxəssisin evində',
  ],
  MobileVisit: [
    'С выездом к клиенту',
    'At the client’s location',
    'Müştərinin ünvanında',
  ],
  ClientHome: ['У клиента', 'At the client’s home', 'Müştərinin evində'],
  Workplace: ['Рабочее помещение', 'Workplace', 'İş yeri'],
  Remote: ['Удалённо', 'Remote', 'Məsafədən'],
  Unspecified: ['Место не указано', 'Location not specified', 'Yer göstərilməyib'],
  serviceProposed: [
    'Предложение отправлено. Услугу можно добавить после одобрения.',
    'Suggestion sent. You can add the service after approval.',
    'Təklif göndərildi. Təsdiqdən sonra xidməti əlavə edə bilərsiniz.',
  ],
  birthdaysToday: ['Сегодня день рождения', 'Birthdays today', 'Bu gün ad günüdür'],
  postUnavailable: [
    'Публикация недоступна',
    'Post unavailable',
    'Paylaşım əlçatmazdır',
  ],
  datingAudience: ['С кем знакомиться', 'Who to meet', 'Kiminlə tanış olmaq'],
  deadline: ['Срок действия', 'Deadline', 'Son tarix'],
  open: ['Открыть', 'Open', 'Aç'],
  feed: ['Лента', 'Feed', 'Lent'],
  gifts: ['Подарки', 'Gifts', 'Hədiyyələr'],
  savePost: ['Сохранить пост', 'Save post', 'Paylaşımı saxla'],
  unsavePost: ['Убрать из сохранённого', 'Unsave post', 'Saxlanmışlardan sil'],
  savedPosts: ['Сохранённые', 'Saved posts', 'Saxlanmış paylaşımlar'],
  followingFeed: ['Мои подписки', 'Following', 'İzlədiklərim'],
  furtOpen: ['Фурт', 'Furt', 'Furt'],
  giftPublicPreview: [
    'Так полку видят другие пользователи',
    'How others see your shelf',
    'Başqalarının gördüyü rəf',
  ],
  deletedAccount: ['Аккаунт удалён', 'Account deleted', 'Hesab silinib'],
  restoreAccountHint: [
    'Для восстановления аккаунта войдите в AURA снова.',
    'Sign in to AURA again to restore your account.',
    'Hesabınızı bərpa etmək üçün AURA-ya yenidən daxil olun.',
  ],
  restoreUntil: [
    'Восстановление доступно до',
    'Restoration available until',
    'Bu tarixədək bərpa mümkündür',
  ],
  scheduleIntervalsHint: [
    'Добавьте рабочие интервалы. Промежутки между ними остаются перерывами.',
    'Add working intervals. Gaps between them remain breaks.',
    'İş intervalları əlavə edin. Aralarındakı boşluqlar fasilədir.',
  ],
  addInterval: ['Добавить интервал', 'Add interval', 'İnterval əlavə et'],
  slotMinutes: ['Длительность слота, мин', 'Slot duration, min', 'Vaxtın müddəti, dəq'],
  moderationWARNING: ['Предупреждение', 'Warning', 'Xəbərdarlıq'],
  moderationSECTION_RESTRICTION: [
    'Раздел временно ограничен',
    'Section temporarily restricted',
    'Bölmə müvəqqəti məhdudlaşdırılıb',
  ],
  moderationACCOUNT_RESTRICTION: [
    'Аккаунт временно ограничен',
    'Account temporarily restricted',
    'Hesab müvəqqəti məhdudlaşdırılıb',
  ],
  moderationACCOUNT_BAN: ['Аккаунт заблокирован', 'Account blocked', 'Hesab bloklanıb'],
  moderationNotice: [
    'Есть решение модерации. Посмотрите причину и доступные действия.',
    'A moderation decision is available. Review the reason and available actions.',
    'Moderasiya qərarı var. Səbəbi və mövcud əməliyyatları yoxlayın.',
  ],
  priceUpperBound: [
    'Цена до, необязательно',
    'Upper price, optional',
    'Maksimum qiymət, istəyə görə',
  ],
  pickMapPoint: [
    'Указать точку на карте',
    'Choose a point on the map',
    'Xəritədə nöqtə seç',
  ],
  birthdayAdultLocked: [
    'Самостоятельно изменить возраст на 18+ нельзя.',
    'You cannot change your age to 18+ yourself.',
    'Yaşınızı özünüz 18+ olaraq dəyişə bilməzsiniz.',
  ],
  birthdayMinorConfirm: [
    'После изменения станут недоступны функции 18+, включая знакомства. Вернуть возраст 18+ самостоятельно будет нельзя. Сохранить дату?',
    '18+ features including Dating will become unavailable. You will not be able to change your age back to 18+ yourself. Save this birthday?',
    'Tanışlıq daxil olmaqla 18+ funksiyalar əlçatmaz olacaq. Yaşınızı özünüz yenidən 18+ edə bilməyəcəksiniz. Tarix saxlanılsın?',
  ],
  login: ['Войти', 'Sign in', 'Daxil ol'],
} as const;
